import { motion } from "framer-motion";

const PEOPLE = [
  {
    name: "Dott.ssa Simona De Vecchis",
    role: "Titolare e responsabile del centro",
    quote: "Ascolto le esigenze e le trasformo in opportunità.",
    bio: "Non mi limito ad ascoltare e individuare il problema, ma costruisco soluzioni.",
  },
  {
    name: "Dott.ssa Emanuela Schietroma",
    role: "Socia e coordinatrice delle attività didattiche",
    quote: "Dalla criticità alla soluzione, dalla soluzione alla prevenzione.",
    bio: "Trasformo gli obblighi in opportunità, i rischi in prevenzione e la prevenzione in cultura.",
  },
];

export const Team = () => {
  return (
    <section data-testid="team-section" className="py-20 md:py-28 bg-white border-b border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_300px] xl:grid-cols-[minmax(0,1fr)_340px] gap-8 lg:gap-14 items-start mb-12">
          <div className="max-w-3xl">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-4">La loro voce</div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tighter text-brand-black leading-[0.95]">
              Simona e Emanuela: la sicurezza raccontata da chi la vive.
            </h2>
            <p className="mt-5 text-brand-ink text-base md:text-lg leading-relaxed">
              Non una sezione anonima: qui parlano le due donne che guidano treffe, con un'idea precisa di formazione — cura, ascolto e responsabilità verso chi lavora e chi nella propria quotidianità vuol vivere in sicurezza, come filosofia di vita.
            </p>
          </div>
          <motion.figure
            data-testid="team-photo"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="w-full max-w-[260px] sm:max-w-[300px] lg:max-w-none mx-auto lg:mx-0 border border-border bg-white"
          >
            <div className="w-full aspect-[4/5] overflow-hidden bg-white">
              <img
                src="/team/simona-emanuela-mobile.jpg?v=3"
                alt="Simona De Vecchis e Emanuela Schietroma, socie di treffe"
                className="w-full h-full object-cover object-center"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
            <figcaption className="px-4 py-3 text-[11px] uppercase tracking-[0.22em] text-brand-ink/60 bg-white">
              Simona e Emanuela · treffe
            </figcaption>
          </motion.figure>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PEOPLE.map((p, i) => (
            <motion.article
              key={p.name}
              data-testid={`team-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="border border-border bg-brand-paper"
            >
              <div className="p-6 md:p-8">
                <h3 className="font-heading font-bold text-2xl text-brand-black">{p.name}</h3>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-brand-red">{p.role}</div>
                <blockquote className="mt-5 border-l-4 border-brand-red pl-4 font-heading text-xl md:text-2xl font-bold text-brand-black leading-tight">
                  “{p.quote}”
                </blockquote>
                <p className="mt-4 text-brand-ink leading-relaxed text-sm md:text-base">{p.bio}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <div className="mt-8 border border-brand-black bg-brand-black text-white p-6 md:p-8" data-testid="team-value">
          <div className="text-[11px] uppercase tracking-[0.26em] text-brand-red mb-3">Il valore aggiunto</div>
          <p className="font-heading text-2xl md:text-3xl font-bold leading-tight max-w-4xl">
            Due donne, una visione condivisa: fare della sicurezza una scelta consapevole e non un semplice obbligo. Con passione e competenza, trasformiamo la prevenzione in cura, responsabilità e valore per le persone e per le aziende.
          </p>
        </div>
      </div>
    </section>
  );
};
